import { useState } from "react";
import type { Me } from "backend/types";
import { api } from "./api";

const COLORS = [
  "#ef4444", "#f97316", "#f59e0b", "#eab308",
  "#84cc16", "#22c55e", "#10b981", "#14b8a6",
  "#06b6d4", "#0ea5e9", "#3b82f6", "#6366f1",
  "#8b5cf6", "#a855f7", "#d946ef", "#ec4899",
];

export function Signup({ onSignedUp }: { onSignedUp: (me: Me) => void }) {
  const [color, setColor] = useState(COLORS[6]);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      const r = await api.signup({ color });
      onSignedUp(r.player);
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Signup failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-parchment">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-white border border-black/5 rounded-2xl p-7 space-y-6 shadow-lg"
      >
        <div className="text-center">
          <div className="font-display text-3xl font-bold">🛍️ dukaan</div>
          <p className="text-sm text-ink/50 mt-1">the small-shop chat game</p>
        </div>

        <div className="rounded-xl bg-parchment-deep/60 p-4 text-center">
          <p className="text-sm text-ink/70">
            You'll be given a <span className="font-semibold">random name</span> when you join.
            Just pick a colour.
          </p>
        </div>

        <div>
          <span className="text-xs uppercase tracking-wide text-ink/40">Your colour</span>
          <div className="mt-2 grid grid-cols-8 gap-2">
            {COLORS.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setColor(c)}
                className={
                  "h-7 w-7 rounded-full border-2 transition " +
                  (color === c ? "border-ink scale-110" : "border-transparent")
                }
                style={{ backgroundColor: c }}
                aria-label={c}
              />
            ))}
          </div>
        </div>

        {err && <p className="text-sm text-red-500">{err}</p>}

        <button
          type="submit"
          disabled={busy}
          className="w-full rounded-xl bg-wa text-white px-4 py-2.5 font-semibold hover:bg-wa-dark disabled:opacity-50 transition"
        >
          {busy ? "…" : "Let's go ▸"}
        </button>
      </form>
    </div>
  );
}
